/**
 * @generated SignedSource<<0b905b0d631ca3ab7289930311d06269>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotoRailContainer_tradePhoto$data = {
  readonly creators: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"PhotoRailContainer_creators">;
  } | null> | null;
  readonly tags: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"PhotoRailContainer_tags">;
  } | null> | null;
  readonly " $fragmentType": "PhotoRailContainer_tradePhoto";
};
export type PhotoRailContainer_tradePhoto$key = {
  readonly " $data"?: PhotoRailContainer_tradePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotoRailContainer_tradePhoto">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotoRailContainer_tradePhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhotoTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "PhotoRailContainer_tags",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SimilarItemsResults",
              "kind": "LinkedField",
              "name": "similarItems",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RailTag_tag"
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotoCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "PhotoRailContainer_creators",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 4
                }
              ],
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RailCreator_items"
                }
              ],
              "storageKey": "items(first:4)"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RailCreator_creator"
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradePhoto",
  "abstractKey": null
};
})();

(node as any).hash = "68456eef606eb4da15c47da3aa378987";

export default node;
